import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa6';
import SideNavBar from './SideNavBar';
import TutorialVideoModal from './TutorialVideoModal';
import whiteTextLogo from '../../white_text_logo.svg';
import './Layout.css';

const Layout = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const isPromptDetailsRoute = location.pathname.startsWith('/prompt/');
  const isAddPromptRoute = location.pathname === '/add-prompt';
  const isWeeklyPlannerRoute = location.pathname === '/weekly-planner';
  const isSurveyRoute = location.pathname === '/survey';
  const isWelcomeRoute = location.pathname === '/welcome';
  const isRoleNotSupportedRoute = location.pathname === '/role-not-supported';
  const isEditRoleRoute = location.pathname === '/edit-role';
  const isAdminRolesRoute = location.pathname.startsWith('/admin/roles');
  const isOnboardingRoute = location.pathname.startsWith('/onboarding');
  const hasSidebar = !isPromptDetailsRoute && !isAddPromptRoute && !isWeeklyPlannerRoute && !isSurveyRoute && !isWelcomeRoute && !isRoleNotSupportedRoute && !isEditRoleRoute && !isAdminRolesRoute && !isOnboardingRoute;
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isTutorialOpen, setIsTutorialOpen] = useState(false);

  console.log('📐 Layout rendered:', { pathname: location.pathname, hasSidebar });

  useEffect(() => {
    setIsSidebarOpen(false);
  }, [location.pathname]);

  const handleOpenTutorial = () => {
    setIsTutorialOpen(true);
  };

  const handleCloseTutorial = () => {
    setIsTutorialOpen(false);
  };

  const handleOpenSidebar = () => {
    setIsSidebarOpen(true);
  };

  const handleCloseSidebar = () => {
    setIsSidebarOpen(false);
  };

  const handleBackClick = () => {
    navigate('/home');
  };

  return (
    <div className={`layout ${hasSidebar ? 'has-sidebar' : 'no-sidebar'}`}>
      <div className="layout-top-bar">
        <img src={whiteTextLogo} alt="Logo" className="layout-top-bar-logo" />
      </div>
      {hasSidebar && (
        <>
          <button
            type="button"
            className="layout-mobile-toggle"
            onClick={handleOpenSidebar}
            aria-label="Open navigation menu"
          >
            <span />
            <span />
            <span />
          </button>
          <SideNavBar
            isMobileOpen={isSidebarOpen}
            onClose={handleCloseSidebar}
            onOpenTutorial={handleOpenTutorial}
          />
          <div
            className={`layout-overlay ${isSidebarOpen ? 'visible' : ''}`}
            onClick={handleCloseSidebar}
            role="presentation"
          />
        </>
      )}
      {(isPromptDetailsRoute || isAddPromptRoute || isEditRoleRoute || isAdminRolesRoute) && (
        <button
          type="button"
          className="layout-mobile-back-button"
          onClick={handleBackClick}
          aria-label="Back to Prompt Library"
        >
          <FaArrowLeft />
        </button>
      )}
      <main className="layout-content">{children}</main>
      <TutorialVideoModal isOpen={isTutorialOpen} onClose={handleCloseTutorial} />
    </div>
  );
};

export default Layout;

